import { createTV } from "tailwind-variants";
import { twMergeConfig } from "../utils/tailwind-merge.js";
const tv = createTV({
    twMergeConfig: twMergeConfig
});
export { tv };
